export const RESET_DATA = "RESET_PAGE";

export const resetData = () => ({
  type: RESET_DATA,
});
